<template>
  <div class="page_container userListPage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/mine' }">我的</el-breadcrumb-item>
        <el-breadcrumb-item>成员管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main_container">
      <el-tabs v-model="activeName" >
        <el-tab-pane label="人员管理" name="first">
          <el-table :data="tabListOne" height="57vh" style="width: 100%">
            <el-table-column prop="accountid" label="账户ID" width="180">
            </el-table-column>
            <el-table-column prop="truename" label="姓名" width="180">
            </el-table-column>
            <el-table-column prop="attrname" label="用户属性" width="180">
            </el-table-column>
            <el-table-column prop="levelname" label="用户等级">
            </el-table-column>
            <el-table-column prop="joinDate" label="申请时间">
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button
                  @click="handleDetail(scope.row)"
                  type="text"
                  size="small"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="加入申请" name="second">
          <el-table :data="tabListTwo" height="57vh" style="width: 100%">
            <el-table-column prop="accountid" label="账户ID" width="180">
            </el-table-column>
            <el-table-column prop="truename" label="姓名" width="180">
            </el-table-column>
            <el-table-column prop="attrname" label="用户属性" width="180">
            </el-table-column>
            <el-table-column prop="levelname" label="用户等级">
            </el-table-column>
            <el-table-column prop="joinDate" label="申请时间">
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button
                  @click="handleDetail(scope.row)"
                  type="text"
                  size="small"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { getApplyCompanyList } from "../../api/company";
export default {
  name: "userList",
  data() {
    return {
      activeName: "first",
      tabListOne: [],
      tabListTwo: [],
    };
  },
  created() {
    this.getApplyCompanyList();
  },
  methods: {
    handleTabs(index) {
      this.tabActive = index;
    },
    getApplyCompanyList() {
      let { qyid } = this.$route.params;
      getApplyCompanyList({ qyid }).then((res) => {
        res.forEach((v) => {
          v.joinDate =
            v.checkdate.split("T")[0] + " " + v.checkdate.split("T")[1];
          v.levelname = v.user.levelname;
          v.attrname = v.user.attrname;
          if (v.checkstate == 1) {
            this.tabListOne.push(v);
          }
          if (v.checkstate == 0) {
            this.tabListTwo.push(v);
          }
        });
      });
    },

    handleDetail(e) {
      let { qyid } = this.$route.params;
      this.$router.push(`/companyIndex/userDetail/${e.openid}/${qyid}/${e.id}`);
    },

  },
};
</script>
<style lang="less" scoped>
.userListPage {
  .main_container {
    margin: 20px auto;
  }
}
</style>